export default __webpack_public_path__ + "static/media/landingg.cc269171.PNG";